import { BigDecimal, LogisticaTiposEntrega } from "@pcgerente-node/pcg-comun";
import { logistica_GUIA_PROFORMA } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { useEffect, useState } from "react";
import img1 from "../../../assets/img/Recurso 3.png";
import CodigoBarra from "../../helpers/CodigoBarra/CoidgoBarra";
import Qr from "../../helpers/Qr/Qr";
import { StyleProps1, StyleProps13, StyleProps14, StyleProps2, StyleProps4, StyleProps7, StyleProps8, StyleProps9, StylesProps11, StylesProps12, StylesProps17, StylesProps5, StylesProps6, estilosImprimir } from "./StylesInLine";

interface ChildsProps {
    guiaProforma: logistica_GUIA_PROFORMA,
    identificador: string    
}
const GuiaIndv:React.FC<ChildsProps> = ({guiaProforma, identificador}) => {
    const[necesitaSaltoDePagina, setNecesitaSaltoDePagina] = useState(false)
    
    const existeElemento = window.document.getElementById(identificador)
    useEffect(() => {
        if(existeElemento)
            setNecesitaSaltoDePagina(calcularAlturaTabla(identificador))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[existeElemento])


    return (
        guiaProforma.CIUDAD_ORIGEN && guiaProforma.CIUDAD_DESTINO && guiaProforma.CLIENTE_REMITENTE && guiaProforma.CLIENTE_DESTINATARIO ?
            <div className="content-section" style={necesitaSaltoDePagina?estilosImprimir: {}}>
                <div className="inv--head-section inv--detail-section">
                    <div className="row" style={StyleProps1}>
                        <div className="col-sm-1 text-center d-flex justify-content-center align-items-center">
                                    <img
                                        className="company-logo "
                                        src={img1}
                                        alt="company"
                                        width="40"
                                        height="40" />
                        </div>
                        <div className="col-sm-2 text-center align-self-center">
                            <table style={{lineHeight: "10px", fontSize: "80%"}}>
                            <tbody>
                                <tr>
                                    <th scope="row" abbr="Guayaquil">
                                        Guayaquil:
                                    </th>
                                    <td>043906260 </td>
                                </tr>
                                <tr>
                                    <th scope="row" abbr="Quito">
                                        Quito:
                                    </th>
                                    <td>022800244 </td>
                                </tr>
                                <tr>
                                    <th scope="row" abbr="Sto. Domingo:">
                                        Sto. Domingo:
                                    </th>
                                    <td>0994190159 </td>
                                </tr>
                                <tr>
                                    <th scope="row" abbr="Machala:">
                                        Machala:
                                    </th>
                                    <td>0992798033 </td>
                                </tr>
                                <tr>
                                    <th scope="row" abbr="Ambato:">
                                        Ambato:
                                    </th>
                                    <td>0985796250 </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-sm-3 text text-center align-self-center">
                            <div className=" " style={StyleProps2}>
                                Operadora Logística del Ecuador Exactocarga
                            </div>
                            <div className=" " style={StyleProps2}>
                                RUC:0993108766001
                            </div>
                            <div className=" " style={StyleProps2}>
                                www.exactocarga.com
                            </div>
                        </div>

                        <div className="col-sm-3 text align-self-center">
                            <div style={StylesProps6}>
                                <table>
                                <tbody>
                                    <tr>
                                        <th
                                            style={StyleProps4}
                                            scope="row"
                                            abbr="Guía"
                                        >
                                            Guía:
                                        </th>
                                        <td>{`${guiaProforma.serie1}-${guiaProforma.serie2}-${guiaProforma.numeroDocumento}`} </td>
                                    </tr>
                                    <tr>
                                        <th
                                            style={StyleProps4}
                                            scope="row"
                                            abbr="Fecha de Envio"
                                        >
                                            Fecha de Envio:
                                        </th>
                                        <td>{`${new Date(guiaProforma.fechaEmision).toLocaleDateString()}`}</td>
                                    </tr>
                                    <tr>
                                        <th
                                            style={StyleProps4}
                                            scope="row"
                                            abbr="Origen:"
                                        >
                                            Origen:
                                        </th>
                                        <td>{`${guiaProforma.CIUDAD_ORIGEN.nombre}`}</td>
                                    </tr>
                                    <tr>
                                        <th
                                            style={StyleProps4}
                                            scope="row"
                                            abbr="Destino:"
                                        >
                                            Destino:
                                        </th>
                                        <td>{`${guiaProforma.CIUDAD_DESTINO.nombre}`} </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-sm-3 text-center d-flex justify-content-around">
                            <CodigoBarra 
                                idGuiaProforma={guiaProforma.id??0}
                                width={1.4} 
                                heigth={70}   
                            />
                            <Qr
                            serie1={guiaProforma.serie1} 
                            serie2={guiaProforma.serie2} 
                            numeroGuia={guiaProforma.numeroDocumento}
                            size={90}
                            />
                        </div>

                        <div className="col-sm-6 text-center mt-2">
                            <div style={StylesProps5}>Remitente</div>
                            <div style={StylesProps6}>
                                <table>
                                <tbody>
                                    <tr>
                                        <th
                                            style={StyleProps4}
                                            scope="row"
                                            abbr="Razon Social"
                                        >
                                            Razon Social:
                                        </th>
                                        <td>{guiaProforma.CLIENTE_REMITENTE.razonSocial}</td>
                                    </tr>
                                    <tr>
                                        <th
                                            style={StyleProps4}
                                            scope="row"
                                            abbr="Ruc/CI"
                                        >
                                            Ruc/CI:
                                        </th>
                                        <td>{guiaProforma.CLIENTE_REMITENTE.cedula}</td>
                                    </tr>
                                    <tr>
                                        <th
                                            style={StyleProps4}
                                            scope="row"
                                            abbr="Teléfono:"
                                        >
                                            Teléfono:
                                        </th>
                                        <td>{guiaProforma.CLIENTE_REMITENTE.telefono}</td>
                                    </tr>
                                    <tr>
                                        <th
                                            style={StyleProps4}
                                            scope="row"
                                            abbr="Dirección:"
                                        >
                                            Dirección:
                                        </th>
                                        <td>{guiaProforma.CLIENTE_REMITENTE.direccion}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-sm-6 text-center mt-2">
                            <div style={StylesProps5}>Destinatario</div>
                            <div style={StylesProps6}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <th
                                                style={StyleProps4}
                                                scope="row"
                                                abbr="Razon Social"
                                            >
                                                Razon Social:
                                            </th>
                                            <td>{guiaProforma.CLIENTE_DESTINATARIO.razonSocial}</td>
                                        </tr>
                                        <tr>
                                            <th
                                                style={StyleProps4}
                                                scope="row"
                                                abbr="Ruc/CI"
                                            >
                                                Ruc/CI:
                                            </th>
                                            <td>{guiaProforma.CLIENTE_DESTINATARIO.cedula}</td>
                                        </tr>
                                        <tr>
                                            <th
                                                style={StyleProps4}
                                                scope="row"
                                                abbr="Teléfono:"
                                            >
                                                Teléfono:
                                            </th>
                                            <td>{guiaProforma.CLIENTE_DESTINATARIO.telefono}</td>
                                        </tr>
                                        <tr>
                                            <th
                                                style={StyleProps4}
                                                scope="row"
                                                abbr="Dirección:"
                                            >
                                                Dirección:
                                            </th>
                                            <td>{guiaProforma.direccionDestinatario}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="inv--product-table-section mt-2">
                        <table className="table table-responsive tablasIndvImprimir"  id='tablaBlock'>
                            <thead className="">
                                <tr style={StyleProps7}>
                                    <th style={StyleProps8} scope="col">Bulto</th>
                                    <th style={StyleProps8} scope="col">Contenido</th>
                                    <th style={StyleProps8} scope="col">Detalles</th>
                                    <th style={StyleProps8} scope="col">Cantidad</th>
                                    <th style={StyleProps8} scope="col">Precio</th>
                                    <th style={StyleProps8} scope="col">Total</th>
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    guiaProforma.logistica_GUIA_PROFORMA_DETALLE?.length ?
                                        guiaProforma.logistica_GUIA_PROFORMA_DETALLE.map((det, i) =>
                                            <tr style={StyleProps8} key={i}>
                                                <td style={{padding:"0", width:"5%", textAlign:"center"}}>{new BigDecimal(det.bultos).toString()}</td>
                                                <td style={{padding:"0", lineHeight:0.8, letterSpacing:"0px",paddingRight:"4px"}}>
                                                    {det.logistica_CONTENIDO?.descripcion}
                                                    </td>
                                                <td style={{padding:"0", lineHeight:0.8, letterSpacing:"0px",paddingRight:"4px"}}>
                                                    {det.detalle}
                                                    </td>
                                                <td style={{padding:"0", width:"8%", textAlign:"center"}}> {new BigDecimal(det.cantidad).toString()}</td>
                                                <td style={{padding:"0", width:"8%", textAlign:"center"}}>${new BigDecimal(det.precio).toString()}</td>
                                                <td style={{padding:"0", width:"8%", textAlign:"center"}}>${new BigDecimal(det.total).toString()}</td>
                                            </tr>
                                        )
                                        : <></>
                                }

                                <tr>
                                    <td style={StyleProps9}>{new BigDecimal(guiaProforma.bultos).toString()}</td>
                                    <td style={StylesProps11}>← TOTAL CAJAS</td>

                                    <td className="text-right"></td>
                                    <td style={StylesProps12} colSpan={2}> TOTAL USD →</td>
                                    <td style={StyleProps9}>${new BigDecimal(guiaProforma.total).toString()}</td>
                                </tr>
                            </tbody>
                        </table>


                        <div className="inv--note">
                                        <table className="table table-responsive tablasIndvImprimir"id='tablaBlock'>
                                            <thead className="">
                                                <tr style={StyleProps4}>
                                                    <th
                                                        style={StyleProps13}
                                                        scope="col"
                                                    >
                                                        FORMA DE PAGO
                                                    </th>
                                                    <th
                                                        style={StyleProps13}
                                                        scope="col"
                                                    >
                                                        TIPO
                                                    </th>
                                                    <th
                                                        style={StyleProps13}
                                                        scope="col"
                                                    >
                                                        FECHA
                                                    </th>
                                                    <th
                                                        style={StyleProps13}
                                                        scope="col"
                                                    >
                                                        # GUIA
                                                    </th>
                                                    <th
                                                        style={StyleProps13}
                                                        scope="col"
                                                    >
                                                        ELABORADA POR
                                                    </th>
                                                    <th
                                                        style={StyleProps13}
                                                        scope="col"
                                                    >
                                                        OBSERVACIONES
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                className="table border=solid 5px"
                                                style={StyleProps14}
                                            >
                                                <tr>
                                                    <td
                                                        style={{...StylesProps17, width:"10.5%"}}
                                                        className="text-left"
                                                    >
                                                        Crédito
                                                    </td>
                                                    <td
                                                        style={{...StylesProps17, width:"8%"}}
                                                        className="text-left"
                                                    >
                                                        {guiaProforma.tipoEntrega === LogisticaTiposEntrega.Domicilio ? "A domicilio"
                                                            : guiaProforma.tipoEntrega === LogisticaTiposEntrega.RetiroOficina ? "Retiro a Oficina"
                                                                : ""
                                                        }
                                                    </td>
                                                    <td
                                                        style={{...StylesProps17, width:"6%"}}
                                                        className="text-left"
                                                    >
                                                        {new Date(guiaProforma.fechaEmision).toLocaleDateString()}
                                                    </td>
                                                    <td
                                                        style={{...StylesProps17, width:"8%"}}
                                                        className="text-left"
                                                    >
                                                        {guiaProforma.serie1}-{guiaProforma.serie2}-{guiaProforma.numeroDocumento}
                                                    </td>
                                                    <td
                                                        style={{...StylesProps17, lineHeight:0.8, width:"15%", letterSpacing:"0px",paddingRight:"4px"}}
                                                        className="text-left"
                                                    >
                                                        {guiaProforma.CLIENTE_REMITENTE.razonSocial}
                                                    </td>
                                                    <td
                                                        style={{...StylesProps17, lineHeight:0.8, letterSpacing:"0px",paddingRight:"4px"}}
                                                        className="text-left"   
                                                    >
                                                        {guiaProforma.observacion}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                            </div>
                        </div>
                </div>
            : <></>
    )

    function calcularAlturaTabla(identificador: string){
        const tabla = window.document.getElementById(identificador) as HTMLDivElement
        if(tabla){
            const alturaPaginaParaImprimir = 1400 //altura que se usa en el formato A4

            const alturaTabla = tabla.clientHeight; // Obtén la altura de la tabla
            const tablasRenderizadas = Number(identificador.replace("tablaIndv", "")) 

            let alturaOcupadaPorTablas = alturaTabla*tablasRenderizadas
            //Si el espacio que sobró entre las ultimas tablas renderizadas es menor a la altura de una tabla 
            //significa que otra tabla ya no pudo caber en la hoja anterior y por lo tanto la nueva tabla se mueve a una nueva hoja
            if(alturaTabla<(alturaOcupadaPorTablas - alturaPaginaParaImprimir)){ 
                alturaOcupadaPorTablas = 0
            }

            return alturaPaginaParaImprimir < (alturaOcupadaPorTablas);
        }
        return false
      };
}



export default GuiaIndv
